(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("zpm", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["zpm"] = factory(require("vue"));
	else
		root["zpm"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_37__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition